export { default, Props } from './CreateAppFooter';
